import styled from "styled-components";
import Colors from "../../Constant/Colors";

export const Container = styled.div`
  background-color: ${Colors.darkWhite};
  height: 100vh;
  width: 100vw;
`;
export const MainContent = styled.div`
  height: calc(100% - 100px);
  width: ${(props) =>
    props.isChatOpen && props.isInstructor
      ? "calc(100% - 500px)"
      : props.isChatOpen
      ? "calc(100% - 500px)"
      : "100%"};
  /* width: 100%; */
  box-sizing: border-box;
  position: absolute;
  right: 0px;
  top: 100px;
  padding: 10px;
  @media only screen and (max-width: 600px) {
    box-sizing: border-box;
    height: calc(100% - 80px);
    width: 100%;
    top: 80px;
  }
`;
